import { render } from "./PosLayout.vue?vue&type=template&id=ed753cc4"
import script from "./PosLayout.vue?vue&type=script&lang=js"
export * from "./PosLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__